<template>
  <div id="excelExporter">
    <component :is="currentComponent" :exportData="exportData" :filter="reqFilter" :asStep="asStep" @prepared="componentPrepared" ref="excelDownloader"/>
  </div>
</template>

<script>
import common from '../../script/common'
import modemInfo from '../../script/modemInfo'
import modemAS from '../../script/modemAS'
import shadowQuality from '../../script/shadowQuality'
import modemStop from '../../script/modemStop'
import user from '../../script/user'
// Excel Download Component
import ExcelDownloadModemInfo from './ExcelDownloadModemInfo.vue'
import ExcelDownloadModemAS from './ExcelDownloadModemAS.vue'
import ExcelDownloadModemASProgress from './ExcelDownloadModemASProgress.vue'
import ExcelDownloadShadowQualityProgress from './ExcelDownloadShadowQualityProgress.vue'
import ExcelDownloadModemStop from './ExcelDownloadModemStop.vue'
import ExcelDownloadModemStopExternal from './ExcelDownloadModemStopExternal.vue'
import ExcelDownloadModemCancel from './ExcelDownloadModemCancel.vue'
import ExcelDownloadModemCancelExternal from './ExcelDownloadModemCancelExternal.vue'
import ExcelDownloadMember from './ExcelDownloadMember.vue'
import axios from 'axios'

export default {
  props: ['filter', 'type'],
  components: {
    ExcelDownloadModemInfo,
    ExcelDownloadModemAS,
    ExcelDownloadModemASProgress,
    ExcelDownloadShadowQualityProgress,
    ExcelDownloadModemStop,
    ExcelDownloadModemStopExternal,
    ExcelDownloadModemCancel,
    ExcelDownloadModemCancelExternal,
    ExcelDownloadMember
  },
  data () {
    return {
      reqType: this.type,
      reqFilter: this.filter,
      currentComponent: null,
      exportData: [],
      isReady: false,
      // Modem A/S
      asStepMapping: {
        modemASAccepted: 2,
        modemASProgress: 3,
        modemASComplete: 4
      },
      asStep: 2,
      isDownloadDone: false
    }
  },
  watch: {
    filter (newVal) {
      this.setFilter(newVal)
    }
  },
  methods: {
    setFilter (newFilter) {
      this.reqFilter = newFilter
    },
    runExport () {
      user.getUser({}, response => {
        console.log('getMyInfo', response)
        this.reqFilter.page = 1
        this.reqFilter.size = 100000
        if (response.data.resultCode === 1) {
          if (this.reqFilter.officeCode == null ||
            this.reqFilter.officeCode === '' ||
            this.reqFilter.officeCode.length <= 0) {
            if (response.data.result.body.officeCode != null &&
              response.data.result.body.officeCode !== '' &&
              response.data.result.body.officeCode.length > 0) {
              this.reqFilter.officeCode = response.data.result.body.officeCode.substring(0, 5)
            }
          }
          this.setCurrentComponentByType()
          this.queryProcess()
        } else {
          this.setCurrentComponentByType()
          this.queryProcess()
        }
      })
    },
    handleResponse (reqType, asStep, response) {
      const logMessages = {
        modem: '[엑셀 다운로드] 모뎀현황 목록',
        modemASAccepted: '[엑셀 다운로드] 모뎀 A/S 접수 목록',
        modemASProgress: '[엑셀 다운로드] 모뎀 A/S 처리중 목록',
        modemASComplete: '[엑셀 다운로드] 모뎀 A/S 완료 목록',
        shadowQualityProgress: '[엑셀 다운로드] 음영∙품질 개선 처리중 목록',
        modemStop: '[엑셀 다운로드] 회선관리: 정지 모뎀정보 엑셀',
        modemStopExternal: '[엑셀 다운로드] 회선관리: 정지 U+업무용 엑셀',
        modemCancel: '[엑셀 다운로드] 회선관리: 정지해제 모뎀정보 엑셀',
        modemCancelExternal: '[엑셀 다운로드] 회선관리: 정지해제 U+업무용 엑셀',
        modemStopList: '[엑셀 다운로드(선택)] 회선관리: 정지 모뎀정보 엑셀',
        modemStopExternalList: '[엑셀 다운로드(선택)] 회선관리: 정지 U+업무용 엑셀',
        modemCancelList: '[엑셀 다운로드(선택)] 회선관리: 정지해제 모뎀정보 엑셀',
        modemCancelExternalList: '[엑셀 다운로드(선택)] 회선관리: 정지해제 U+업무용 엑셀',
        member: '[엑셀 다운로드] 계정관리 목록'
      }
      console.log(logMessages[reqType], response)
      if (response.data.resultCode === 1) {
        let list = response.data.result.body
        this.exportData = list
        // data trimmed
        if (list.length > 0) {
          let trimmedList = list.map(item => this.trimStrings(item))
          this.exportData = trimmedList
        }
        // date format
        if (reqType === 'modemStop' || reqType === 'modemStopExternal' ||
          reqType === 'modemCancel' || reqType === 'modemCancelExternal') {
          for (let item of this.exportData) {
            item.regDateFormatted = item.regDate ? item.regDate.slice(0, 10).replaceAll('-', '') : ''
          }
        }
        this.asyncDownload()
      } else {
        common.amsAlert('retry', '다운로드에 실패했습니다.')
        this.$emit('fail')
      }
    },
    trimStrings (obj) {
      if (typeof obj === 'string') {
        return obj.trim()
      } else if (Array.isArray(obj)) {
        return obj.map(item => this.trimStrings(item))
      } else if (typeof obj === 'object' && obj !== null) {
        const trimmedObj = {}
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            trimmedObj[key] = this.trimStrings(obj[key])
          }
        }
        return trimmedObj
      }
      return obj
    },
    queryProcess () {
      if (this.reqType === 'modem') {
        modemInfo.getModemInfo(this.reqFilter, response => {
          this.handleResponse(this.reqType, null, response)
        })
      } else if (this.reqType === 'modemASAccepted' || this.reqType === 'modemASProgress' || this.reqType === 'modemASComplete') {
        this.reqFilter.asStep = this.asStepMapping[this.reqType]
        modemAS.getModemAS(this.reqFilter, response => {
          this.handleResponse(this.reqType, this.reqFilter.asStep, response)
        })
      } else if (this.reqType === 'shadowQualityProgress') {
        shadowQuality.getQuality(this.reqFilter, response => {
          this.handleResponse(this.reqType, null, response)
        })
      } else if (this.reqType === 'modemStop' || this.reqType === 'modemStopExternal' || this.reqType === 'modemCancel' || this.reqType === 'modemCancelExternal') {
        modemStop.getModemStop(this.reqFilter, response => {
          this.handleResponse(this.reqType, null, response)
        })
      } else if (this.reqType === 'modemStopList' || this.reqType === 'modemStopExternalList' || this.reqType === 'modemCancelList' || this.reqType === 'modemCancelExternalList') {
        this.exportData = []
        const promises = []
        for (const item of this.reqFilter.groupList) {
          let data = { ...this.reqFilter }
          if (this.reqType === 'modemStopList' || this.reqType === 'modemStopExternalList') {
            data.groupPid = item.stopGroupPid
          } else if (this.reqType === 'modemCancelList' || this.reqType === 'modemCancelExternalList') {
            data.groupPid = item.csGroupPid
          }
          delete data['groupList']
          const promise = axios.get('/api/modem/stop', { params: data }, {
            headers: {
              'authorization': sessionStorage.getItem('accessToken'),
              'authorization-refresh': sessionStorage.getItem('accessTokenRefresh')
            }
          })
            .then(response => {
              if (response.data.resultCode === 1) {
                let list = response.data.result.body
                if (list.length > 0) {
                  let trimmedList = list.map(item => this.trimStrings(item))
                  list = trimmedList
                }
                // U+업무용엑셀
                for (let item of list) {
                  item.regDateFormatted = item.regDate ? item.regDate.slice(0, 10).replaceAll('-', '') : ''
                }
                this.exportData = this.exportData.concat(list)
              }
            })
            .catch(error => {
              console.error(error)
            })
          promises.push(promise)
        }
        Promise.all(promises).then(() => {
          this.asyncDownload()
        }).catch(error => {
          console.error(error)
          common.amsAlert('retry', '다운로드에 실패했습니다.')
          this.$emit('fail')
        })
      } else if (this.reqType === 'member') {
        user.getUser(this.reqFilter, response => {
          this.handleResponse(this.reqType, null, response)
        })
      }
    },
    async asyncDownload () {
      await common.sleepFor(10, 500, () => { return this.isReady })
      this.$refs.excelDownloader.download()
      setTimeout(() => {
        if (this.exportData.hasNext) {
          this.reqFilter.page++
          this.queryProcess()
        } else {
          this.$emit('downloading')
        }
      }, 1000)
    },
    componentPrepared () {
      this.isReady = true
    },
    setCurrentComponentByType () {
      this.isReady = false
      if (this.reqType === 'modem') {
        this.currentComponent = 'ExcelDownloadModemInfo'
      } else if (this.reqType === 'modemASAccepted' || this.reqType === 'modemASComplete') {
        this.asStep = this.asStepMapping[this.reqType]
        this.currentComponent = 'ExcelDownloadModemAS'
      } else if (this.reqType === 'modemASProgress') {
        this.asStep = this.asStepMapping[this.reqType]
        this.currentComponent = 'ExcelDownloadModemASProgress'
      } else if (this.reqType === 'shadowQualityProgress') {
        this.currentComponent = 'ExcelDownloadShadowQualityProgress'
      } else if (this.reqType === 'modemStop' || this.reqType === 'modemStopList') {
        this.currentComponent = 'ExcelDownloadModemStop'
      } else if (this.reqType === 'modemStopExternal' || this.reqType === 'modemStopExternalList') { // U+업무용엑셀
        this.currentComponent = 'ExcelDownloadModemStopExternal'
      } else if (this.reqType === 'modemCancel' || this.reqType === 'modemCancelList') {
        this.currentComponent = 'ExcelDownloadModemCancel'
      } else if (this.reqType === 'modemCancelExternal' || this.reqType === 'modemCancelExternalList') { // U+업무용엑셀
        this.currentComponent = 'ExcelDownloadModemCancelExternal'
      } else if (this.reqType === 'member') {
        this.currentComponent = 'ExcelDownloadMember'
      } else {
        this.$emit('fail')
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/excel/ExcelExporter.vue